import {LOCALES} from '@homebase/provider';

export const DATE_FORMATS = {
  // 9/5/19
  M_D_YY: 'M_D_YY',
  // 9/5/2019
  M_D_YYYY: 'M_D_YYYY',
  // 09/05/2019
  MM_DD_YYYY: 'MM_DD_YYYY',
  // Sep 5, 2019
  MMM_D_YYYY: 'MMM_D_YYYY',
  // September 5, 2019
  MMMM_D_YYYY: 'MMMM_D_YYYY',
};

export const LOCALE_DATE_FORMATS = {
  [DATE_FORMATS.M_D_YY]: {
    // 5.9.19
    [LOCALES.de]: 'D.M.YY',
    [LOCALES['de-DE']]: 'D.M.YY',
    // 9/5/19
    [LOCALES.en]: 'M/D/YY',
    [LOCALES['en-US']]: 'M/D/YY',
    [LOCALES['en-US-x-am']]: 'M/D/YY',
    [LOCALES['en-US-x-bl']]: 'M/D/YY',
    [LOCALES['en-US-x-jm']]: 'M/D/YY',
    [LOCALES['en-US-x-pg']]: 'M/D/YY',
    // 5/9/19
    [LOCALES['en-CA']]: 'D/M/YY',
    // 5/9/19
    [LOCALES.es]: 'D/M/YY',
    // 5/9/19
    [LOCALES['en-GB']]: 'D/M/YY',
    // 5/9/19
    [LOCALES.fr]: 'D/M/YY',
    // 5/9/19
    [LOCALES['fr-CA']]: 'D/M/YY',
  },
  [DATE_FORMATS.M_D_YYYY]: {
    // 5.9.2019
    [LOCALES.de]: 'D.M.YYYY',
    [LOCALES['de-DE']]: 'D.M.YYYY',
    // 9/5/2019
    [LOCALES.en]: 'M/D/YYYY',
    [LOCALES['en-US']]: 'M/D/YYYY',
    [LOCALES['en-US-x-am']]: 'M/D/YYYY',
    [LOCALES['en-US-x-bl']]: 'M/D/YYYY',
    [LOCALES['en-US-x-jm']]: 'M/D/YYYY',
    [LOCALES['en-US-x-pg']]: 'M/D/YYYY',
    // 5/9/2019
    [LOCALES['en-CA']]: 'D/M/YYYY',
    // 5/9/2019
    [LOCALES.es]: 'D/M/YYYY',
    // 5/9/2019
    [LOCALES['en-GB']]: 'D/M/YYYY',
    // 5/9/2019
    [LOCALES.fr]: 'D/M/YYYY',
    // 5/9/2019
    [LOCALES['fr-CA']]: 'D/M/YYYY',
  },
  [DATE_FORMATS.MM_DD_YYYY]: {
    // 05.09.2019
    [LOCALES.de]: 'DD.MM.YYYY',
    [LOCALES['de-DE']]: 'DD.MM.YYYY',
    // 09/05/2019
    [LOCALES.en]: 'MM/DD/YYYY',
    [LOCALES['en-US']]: 'MM/DD/YYYY',
    [LOCALES['en-US-x-am']]: 'MM/DD/YYYY',
    [LOCALES['en-US-x-bl']]: 'MM/DD/YYYY',
    [LOCALES['en-US-x-jm']]: 'MM/DD/YYYY',
    [LOCALES['en-US-x-pg']]: 'MM/DD/YYYY',
    // 05/09/2019
    [LOCALES['en-CA']]: 'DD/MM/YYYY',
    // 05/09/2019
    [LOCALES.es]: 'DD/MM/YYYY',
    // 05/09/2019
    [LOCALES['en-GB']]: 'DD/MM/YYYY',
    // 05/09/2019
    [LOCALES.fr]: 'DD/MM/YYYY',
    // 05/09/2019
    [LOCALES['fr-CA']]: 'DD/MM/YYYY',
  },
  [DATE_FORMATS.MMM_D_YYYY]: {
    // 5 Sep 2019
    [LOCALES.de]: 'D MMM YYYY',
    [LOCALES['de-DE']]: 'D MMM YYYY',
    // Sep 5, 2019
    [LOCALES.en]: 'MMM D, YYYY',
    [LOCALES['en-US']]: 'MMM D, YYYY',
    [LOCALES['en-US-x-am']]: 'MMM D, YYYY',
    [LOCALES['en-US-x-bl']]: 'MMM D, YYYY',
    [LOCALES['en-US-x-jm']]: 'MMM D, YYYY',
    [LOCALES['en-US-x-pg']]: 'MMM D, YYYY',
    // 5 Sep 2019
    [LOCALES['en-CA']]: 'D MMM YYYY',
    // 5 Sep 2019
    [LOCALES.es]: 'D MMM YYYY',
    // 5 Sep 2019
    [LOCALES['en-GB']]: 'D MMM YYYY',
    // 5 Sep 2019
    [LOCALES.fr]: 'D MMM YYYY',
    // 5 Sep 2019
    [LOCALES['fr-CA']]: 'D MMM YYYY',
  },
  [DATE_FORMATS.MMMM_D_YYYY]: {
    // 5 September 2019
    [LOCALES.de]: 'D MMMM YYYY',
    [LOCALES['de-DE']]: 'D MMMM YYYY',
    // September, 5 2019
    [LOCALES.en]: 'MMMM D, YYYY',
    [LOCALES['en-US']]: 'MMMM D, YYYY',
    [LOCALES['en-US-x-am']]: 'MMMM D, YYYY',
    [LOCALES['en-US-x-bl']]: 'MMMM D, YYYY',
    [LOCALES['en-US-x-jm']]: 'MMMM D, YYYY',
    [LOCALES['en-US-x-pg']]: 'MMMM D, YYYY',
    // 5 September 2019
    [LOCALES['en-CA']]: 'D MMMM YYYY',
    // 5 September 2019
    [LOCALES.es]: 'D MMMM YYYY',
    // 5 September 2019
    [LOCALES['en-GB']]: 'D MMMM YYYY',
    // 5 September 2019
    [LOCALES.fr]: 'D MMMM YYYY',
    // 5 September 2019
    [LOCALES['fr-CA']]: 'D MMMM YYYY',
  },
};

export const getDateFormatForLocale = (format, locale) => {
  if (!DATE_FORMATS[format] || !LOCALE_DATE_FORMATS[format]) {
    return LOCALE_DATE_FORMATS[DATE_FORMATS.M_D_YYYY][LOCALES.en];
  }

  return (
    LOCALE_DATE_FORMATS[format][locale] ||
    LOCALE_DATE_FORMATS[format][LOCALES.en]
  );
};
